const GEOPACKAGE2GEOJSON_URL = '/open/base/util/convert/geopackage2geojson';

const GEOJSON2GEOPACKAGE_URL = '/open/base/util/convert/geojson2geopackage';

export namespace BaseApi {
  export const geopackage2geojson = async (data: FormData): Promise<Response> =>
    fetch(GEOPACKAGE2GEOJSON_URL, {
      method: 'POST',
      body: data
    });

  export const geojson2geopackage = async (data: FormData): Promise<Response> =>
    fetch(GEOJSON2GEOPACKAGE_URL, {
      method: 'POST',
      body: data
    });
}
